export const OPEN_MODAL = 'open_modal';
export const CLOSE_MODAL = 'close_modal';
export const OPEN_ALERT_MODAL = 'open_alert_modal';
export const CLOSE_ALERT_MODAL = 'close_alert_modal';
export const OPEN_DRAWER = 'open_drawer';
export const CLOSE_DRAWER = 'close_drawer';
export const OPEN_PAGE = 'open_page';
export const RELOAD_COMPONENT = 'reload_component';
